/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import { QueryData, ResponseData } from "../services/network/NetworkTypes";

export type CategoryAttribute = {
  value: string;
  label: string;
};

type UNSelectOption<T> = {
  label: string;
  value: string;
};

export type CategoryAttributes = Array<CategoryAttribute>;

export default class Category {
  constructor(
    public value: string,
    public label: string
  ) {}

  static fromJSON(json: Record<string, any>): Category[] {
    /*
    Example input JSON:
    {
        "count": 5,
        "next": null,
        "previous": null,
        "results": [
            { "id": 1, "name": "Personal" },
            { "id": 2, "name": "Family" },
            { "id": 3, "name": "Work" },
            { "id": 4, "name": "Training" },
            { "id": 5, "name": "Other" }
        ]
    }
    */
    const results: Array<Record<string, any>> = json.results || [];
    return results.map((item) => new Category(item.id + "", item.name));
  }

  toJSON(): Record<string, any> {
    return {
      id: this.value,
      name: this.label,
    };
  }
  toUNSelectOption(): UNSelectOption<string> {
    return {
      label: this.label,
      value: this.value.toString(), // Convert to string for compatibility
    };
  }

  static toUNSelectOptions(
    categories: CategoryResponseData
  ): UNSelectOption<string>[] {
    return categories.map((category) => category.toUNSelectOption());
  }
}

export type CategoryQueryData = QueryData<"value" | "label", "value" | "label">;

export type CategoryResponseData = Category[];
